export default {
    "items": [
        {
            "text": "Please Add Each Successor",
            "type": "data-table",
            "name": "successor-information",
            "props": {
                "headers": [
                    {
                        "text": "Name",
                        "value": "full-name"
                    },
                    {
                        "text": "Title",
                        "value": "title"
                    }
                ],
                "newItemLabel": "Add New Successor",
                "noDataLabel": "Please Add a Successor"
            }
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/succession-archive/valuation-data/successor.js